import {useTranslation} from 'react-i18next'

import {LinkButton} from '@sdox/ui'
import {IconExternalLink} from '@sdox/icons'

import type {LinkButtonProps} from '@sdox/ui'

export const GoogleMapsButton = (props: LinkButtonProps) => {
  const {t} = useTranslation()

  return (
    <LinkButton
      target={'_blank'}
      rel={'noopener noreferrer'}
      leading={<IconExternalLink/>}
      aria-label={t('common:googleMaps')}
      title={t('common:googleMaps')}
      {...props}
    />
  )
}
